module.exports = __webpack_public_path__ + "media/music/jazzy_bass_5-52cc7b8b.mp3";